export const SESSION_STORAGE_BUDGET_VALUE = "ic_budgetValue";
export const SESSION_STORAGE_BUDGET_POPUP = "ic_budgetPopup";

export default {
  SESSION_STORAGE_BUDGET_VALUE,
  SESSION_STORAGE_BUDGET_POPUP,
};
